import React from 'react';
import PropTypes from 'prop-types';

import BoxscorePlayerRow from './BoxscorePlayerRow';

const BOXSCORE_FIELDS = [
  'min',
  'fg',
  '3pt',
  'ft',
  'oreb',
  'dreb',
  'reb',
  'ast',
  'stl',
  'blk',
  'to',
  'pf',
  '+/-',
  'pts',
];

const SimpleBoxscore = ({ side }) => (
  <table className="s-game-explorer__boxscore__side__table">
    <thead>
      <tr className="header">
        <th className="s-game-explorer__boxscore__side__table--name">Player</th>
        {BOXSCORE_FIELDS.map(field => (
          <th key={field}>{field.toUpperCase()}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {side.players &&
        side.players.map(playerBoxscore => (
          <BoxscorePlayerRow
            key={playerBoxscore.id}
            player={playerBoxscore.player}
            boxscore={playerBoxscore.boxscore}
          />
        ))}
      <BoxscorePlayerRow
        key={side.team.id}
        boxscore={side.team.boxscore}
        total={true}
      />
    </tbody>
  </table>
);

const BoxscoreSide = ({ side, label }) => {
  return (
    <div className="s-game-explorer__boxscore__side">
      <div className="s-game-explorer__boxscore__side--header">
        <div
          className={`s-game-explorer__boxscore__side--logo ${side.team.team
            .image && 'is-fade-loaded'}`}
          style={
            side.team.team.image && {
              backgroundImage: `url(${side.team.team.image})`,
            }
          }
        />
        <div className="s-game-explorer__boxscore__side--team">
          [{side.team.team.name_short}] {side.team.team.name} (
          {side.team.boxscore.pts})
        </div>
        <div className="s-game-explorer__boxscore__side--label">{label}</div>
      </div>

      <SimpleBoxscore side={side} />
    </div>
  );
};

BoxscoreSide.propTypes = {
  side: PropTypes.object,
  label: PropTypes.string.isRequired,
};

export default BoxscoreSide;
